export enum UserRole {
  Admin = 'admin',
  StrategyProvider = 'strategy_provider',
  User = 'user',
  Editor = 'editor'
}

export interface Strategy {
  id: string;
  name: string;
  description?: string;
  provider_id?: string;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  approved?: boolean;
  exchange: string; // Made required
  risk_level: number; // Already required
  min_investment: number; // Already required
  avg_trades_per_day?: number;
  win_rate?: number;
  avg_profit_per_trade?: number;
  profit_30d?: number;
  profit_90d?: number;
  profit_365d?: number;
  plan_type?: string;
  currency?: string;
  monthly_price?: number;
  yearly_price?: number;
  performance_percentage?: number; // Now optional to match MarketplaceStrategy
  
  // Additional fields used in the application
  plan?: string;
  expected_monthly_profit?: number;
  defined_max_drawdown?: number;
  verified_since?: string;
  compounding?: boolean;
  risk_corridor?: boolean;
  product?: string;
  social_trading?: string[];
  traded_symbols?: string[];
  strategy_provider_id?: string;
  is_active?: boolean;
  followers_count: number; // Made required
}

export interface UserInfo {
  id: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  created_at?: string;
}

export interface StrategyProvider {
  id: string;
  name: string;
  url?: string;
  description?: string;
  active?: boolean;
  created_at?: string;
  updated_at?: string;
  provider_name?: string; // Added for compatibility
}

export interface ProviderWithUser extends StrategyProvider {
  user?: UserInfo;
}

export type SubscriptionPlan = 'monthly' | 'yearly';

// Additional interfaces needed by the application

export interface StrategyWithDetails extends Strategy {
  strategy_name?: string;
  performance_percentage?: number;
  performance_since?: string;
  total_followers?: number;
  total_aum?: number;
  trades_won?: number;
  trades_lost?: number;
  max_drawdown?: number;
  is_pro?: boolean;
  provider_name?: string; // Added for compatibility
  strategy_id?: string; // Added for compatibility
}

export interface StrategyPerformance {
  id: string;
  strategy_id: string;
  account_id?: string; // Added for compatibility
  timestamp: string;
  win_rate?: number;
  max_drawdown?: number;
  pnl_ratio?: number;
  total_trades?: number;
  num_followers?: number; // Added for compatibility
  num_wins?: number; // Added for compatibility
  num_losses?: number; // Added for compatibility
}

export interface Account {
  id: string;
  external_id: string;
  performance_url?: string;
  exchange: string;
  active?: boolean;
  is_primary?: boolean;
  created_at?: string;
  updated_at?: string;
  lead_account_id: string;
  strategy_id: string;
}

export interface LeadAccount {
  id: string;
  external_id: string;
  exchange: string;
  active?: boolean;
  created_at?: string;
  updated_at?: string;
  strategy_provider_id: string;
  provider_name?: string; // Added for compatibility
}

export interface MarketplaceStrategy extends StrategyWithDetails {
  provider_name?: string;
  is_followed?: boolean;
  strategy_name: string; // Made required for compatibility
  followed_at?: string; // Added for compatibility
  name: string; // Made required for compatibility
  min_investment: number; // Already required
  risk_level: number; // Already required
  exchange: string; // Made required
  followers_count: number; // Made required
  strategy_id?: string; // Added for compatibility
  performance_percentage?: number; // Now optional to match the actual use in code
}

export interface FollowStrategyData {
  strategy: {
    id: string;
    name: string;
    performance: string;
    riskLevel: string;
    minInvestment: string;
    since: string;
    exchange: string;
    description?: string;
    strategy_id?: string; // Added for compatibility
  };
  userId?: string; // Added for compatibility
  originalStrategyId: string;
}
